const routes = {
  login: '/login',
  signup: '/signup',
  loginOTP: '/login-otp',
  verifyNumber: '/verify-number',
  verifyEmail: '/verify-email',
  verifiedOTP: '/otp-verified',
  newApplication: '/form',
  applicationForm: '/application',
  applications: '/applications',
  history: '/history',
  offerLetter: '/offerLetter',
  onboardQues: '/onboardQues',
  interviewSlots: '/interviewSlots',
  interview: '/interview',
  landingPage: '/',
  demlandingpage: '/digital-enterprise-management',
  gscmlandingpage: '/global-supply-chain-management',
  success: '/success',
  verify: '/verify',
  resetpassword: '/reset-password-request',
  embalandingpage:'/executive-mba',
  spmlandingpage:'/summer-program-management',
  phdlandingpage:'/doctor-of-philosophy',
  ephdlandingpage:'/executive-phd',
  twoyearmbaInternationallandingpage:'/two-year-mba-international',
  commonInternationalLandingPage:'/common-international-mba',

  // Layout Routes
  resetPasswordMain: '/app/reset-password',
  home: '/app/home',
  document: '/app/document',
  myApplications: '/app/my-applications',
  feePayments: '/app/feePayments',
  feeStructure: '/app/feeStructure',
  courses: '/app/courses',
  postApplication: '/app/post-application',
  feeDetails: '/app/feeDetails',
  withdrawal: '/app/withdraw',
  withdrawalDetails: '/app/withdrawDetails',
  feePaymentHistory: '/app/paymentHistory',
  faq: '/app/faq',
  elibility: '/app/eligibility',
  verify: 'verify',
  confirmation: '/lead/confirmation',
  resendVerification: '/resend-verification',
  queryHistory:'/app/queryHistory',
  queryView:'/app/queryView',
  studentInterviewTab: '/app/studentInterviewTab',
  slotInterviewBooking: '/app/slotInterviewBooking'
};
export default routes;
